export default {"src":"/_next/static/media/product-icon.2d23104f.svg","height":32,"width":33,"blurWidth":0,"blurHeight":0};